const truncateString = (string: string, startLength = 3, endLength = 2) => {
    if (!string) return '';
    if (string.length <= startLength + endLength) return string;
    return `${string.substring(0, startLength)}...${string.substring(string.length - endLength)}`;
};

export default truncateString;
